module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_9005.64ad271e.png";